module.exports = function findFeaturedVideo(relationships) {
	let media_field_name = relationships
		? ["field_media_video"].find(
				(img_field_key) =>
					relationships[img_field_key] && relationships[img_field_key].data
		  )
		: null;
	let media_rel = media_field_name ? relationships[media_field_name].data : null;
	return media_rel;
};
